import clsx from 'clsx';
import IconButton from '@mui/material/IconButton';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import PageBreadcrumb from '@/components/PageBreadcrumb';
import NavigationTitle from '@/components/NavigationTitle';
import SettingsAppNavigation from './SettingsAppNavigation';
import useThemeMediaQuery from '@/@fuse/hooks/useThemeMediaQuery';

type SettingsAppHeaderProps = {
	className?: string;
	onSetSidebarOpen: (open: boolean) => void;
};

function SettingsAppHeader(props: SettingsAppHeaderProps) {
	const { className, onSetSidebarOpen } = props;
	const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

	return (
		<div className={clsx('flex space-x-3', className)}>
			<div>
				<div className='flex gap-3 items-center'>
					{isMobile && (
						<IconButton
							className="border border-divider"
							onClick={() => onSetSidebarOpen(true)}
							aria-label="open left sidebar"
						>
							<FuseSvgIcon>heroicons-outline:bars-3</FuseSvgIcon>
						</IconButton>
					)}
					<PageBreadcrumb className="mb-2" />
				</div>

				<NavigationTitle navigationItems={SettingsAppNavigation.children} />
			</div>
		</div>
	);
}

export default SettingsAppHeader;
